import { render, staticRenderFns } from "./vs-form-richtext.vue?vue&type=template&id=12f66001&scoped=true&lang=true"
import script from "./vs-form-richtext.vue?vue&type=script&lang=js"
export * from "./vs-form-richtext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f66001",
  null
  
)

export default component.exports